RA.ListCommunities = {
  init() {
    let url = Config.contextPath + "/controller/socialbrowse/json";
    let data = {type: "communities" };

    $.get(url, data)
      .done(this.communitiesDone)
      .fail(RA.handleAjaxError);
  },
  communitiesDone(r) {
    let component;

    if (r.communities.length) {
      component = <CommunityShortcut communities={r.communities}  />;
    } else {
      component = <NoContent message={Labels.getLabel("No communities have been set up")} />;
    }

    ReactDOM.render(component, document.getElementById("browseCommunityTiles"));
  }
};